// Translation: English > Time
const time = Object.freeze({
	day_one: 'Day',
	day_other: 'Days',
	dayInShort: 'D',
	dayWithType_one: '{{type}} day',
	dayWithType_other: '{{type}} days',
	frequencyItems: {
		once: 'Once',
		perUse: 'Per use'
	},
	hour_one: 'Hour',
	hour_other: 'Hours',
	hourInShort: 'h',
	hourWithType_one: '{{type}} hour',
	hourWithType_other: '{{type}} hours',
	minute_one: 'Minute',
	minute_other: 'Minutes',
	minuteInShort: 'm',
	minuteWithType_one: '{{type}} minute',
	minuteWithType_other: '{{type}} minutes',
	month_one: 'Month',
	month_other: 'Months',
	monthInShort: 'M',
	monthWithType_one: '{{type}} month',
	monthWithType_other: '{{type}} months',
	rangeItems: {
		last24Hours: 'Last 24 hours',
		last30Days: 'Last 30 days',
		last7Days: 'Last 7 days',
		thisMonth: 'This month',
		thisWeek: 'This week',
		thisYear: 'This year',
		today: 'Today'
	},
	second_one: 'Second',
	second_other: 'Seconds',
	secondInShort: 's',
	secondWithType_one: '{{type}} second',
	secondWithType_other: '{{type}} seconds'
})

// Export
export default time
